import React from 'react';
import ChipEdit from 'ChipEdit';
import Chip from 'Chip';
import transform from 'chipDataTransform';
import PropTypes from 'prop-types';
import styles from './index.css';
import Header from './header/';
import Content from './content/';
import Footer from '../../../components/footer';
import errorBoundary from '@ifeng/errorBoundary';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    /**
     * 渲染网页布局
     */
    render() {
        const { content } = this.props;

        const {
            docData,
            docData: { breadCrumbdata },
            slideData,
            recommendData,
            bookRecommendData,
            footer,
            asideAd1,
            infoAd,
            hardAd2,
            asideAd2,
            hardAd1,
            infoAd5,
            slidelastAd,
            bookRecommendAd,
            floatAd3,
            floatAd5,
            ppxAd,
            logoPPX,
        } = content;

        const contentData = {
            docData,
            slideData,
            recommendData,
            bookRecommendData,
            asideAd1,
            infoAd,
            hardAd2,
            asideAd2,
            hardAd1,
            infoAd5,
            slidelastAd,
            bookRecommendAd,
            floatAd3,
            floatAd5,
            logoPPX,
            ppxAd: ppxAd ? ppxAd.slide_ppposition_live1 : [],
        };

        const headerData = {
            breadCrumbdata,
        };

        return (
            <div>
                <Header headerData={headerData} />
                <Content
                    content={contentData}
                    docData={docData}
                    slideData={slideData}
                    recommendData={recommendData}
                    bookRecommendData={bookRecommendData}
                />
                <div className={styles.footer}>
                    <Chip id="20036" type="struct" title="底部版权" groupName="底部" content={footer}>
                        <Footer />
                    </Chip>
                </div>
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
